export default (theme) => ({
  formContainer: { flexGrow: 1 },
  formItem: { padding: theme.spacing(4) },
  sectionTitle: { marginTop: theme.spacing(2) },
  removeLeftPadding: { paddingLeft: 0 },
  formControl: { marginBottom: theme.spacing(3) },
  formControlDownshift: {
    marginBottom: theme.spacing(1),
    width: '100%',
  },
  selectInput: { padding: '8px 24px 6px 8px' },
  mediumInput: {
    width: 500,
    maxWidth: '100%',
  },
  accordian: {
    boxShadow: 'none',
    '&:before': { display: 'none' },
  },
  accordianDetails: { flexDirection: 'column' },
});
